
  (function() {
    const ua = navigator.userAgent;

    if (/Chrome/i.test(ua) && !/Edge/i.test(ua) && !/OPR/i.test(ua)) {
      document.body.classList.add('browser-chrome');
    } else if (/Safari/i.test(ua) && !/Chrome/i.test(ua)) {
      document.body.classList.add('browser-safari');
    } else if (/Firefox/i.test(ua)) {
      document.body.classList.add('browser-firefox');
    } else if (/Edg/i.test(ua)) {
      document.body.classList.add('browser-edge');
    } else if (/OPR/i.test(ua)) {
      document.body.classList.add('browser-opera');
    } else {
      document.body.classList.add('browser-other');
    }
  })();


    (function() {
    const ua = navigator.userAgent;

    // Detect iPad (iOS 12 and below use "iPad", iOS 13+ can show "Macintosh" with touch)
    if (/iPad|Macintosh/i.test(ua) && 'ontouchend' in document) {
      document.body.classList.add('device-ipad');
    }
  })();

    // Header Dropdown on hover

(function () {
  var HOVER_DELAY = 150; // ms — prevents flicker on accidental mouse-overs

  function initHoverMenus() {
    var details = document.querySelectorAll('.mega-menu');

    details.forEach(function (summary) {
      var detail = summary.closest('details');
      if (!detail) return;

      var closeTimer;
      var openTimer;

      // ── OPEN on mouse enter (on the summary) ──────────────────────────
      summary.addEventListener('mouseenter', function () {
        clearTimeout(closeTimer);
        openTimer = setTimeout(function () {
          closeAllExcept(detail);
          openDropdown(detail);
        }, HOVER_DELAY);
      });

      // ── KEEP OPEN when mouse moves into the submenu ───────────────────
      var submenu = detail.querySelector('.header__submenu');
      if (submenu) {
        submenu.addEventListener('mouseenter', function () {
          clearTimeout(closeTimer);
        });

        submenu.addEventListener('mouseleave', function () {
          closeTimer = setTimeout(function () {
            closeDropdown(detail);
          }, HOVER_DELAY);
        });
      }

      // ── CLOSE when mouse leaves the summary ───────────────────────────
      summary.addEventListener('mouseleave', function () {
        clearTimeout(openTimer);
        closeTimer = setTimeout(function () {
          closeDropdown(detail);
        }, HOVER_DELAY);
      });
    });

    // ── CLOSE all when mouse leaves the entire header ─────────────────
    var header = document.querySelector('.header__inline-menu, header');
    if (header) {
      header.addEventListener('mouseleave', function () {
        closeAll();
      });
    }
  }

  function openDropdown(detail) {
    detail.setAttribute('open', '');
    var summary = detail.querySelector('summary');
    if (summary) summary.setAttribute('aria-expanded', 'true');
  }

  function closeDropdown(detail) {
    detail.removeAttribute('open');
    var summary = detail.querySelector('summary');
    if (summary) summary.setAttribute('aria-expanded', 'false');
  }

  function closeAll() {
    document.querySelectorAll('.header__menu-item-1').forEach(function (summary) {
      var detail = summary.closest('details');
      if (detail) closeDropdown(detail);
    });
  }

  function closeAllExcept(current) {
    document.querySelectorAll('.header__menu-item-1').forEach(function (summary) {
      var detail = summary.closest('details');
      if (detail && detail !== current) closeDropdown(detail);
    });
  }

  // ── Init on DOM ready ────────────────────────────────────────────────
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initHoverMenus);
  } else {
    initHoverMenus();
  }
})();



function debounce(fn, delay) {
  let timer;
  return function() {
    clearTimeout(timer);
    timer = setTimeout(fn, delay);
  };
}

function setAnnouncementHeight() {
  const announcementBar = document.querySelector('.announcement-bar-section');

  if (announcementBar && announcementBar.offsetHeight > 0) {
    document.documentElement.style.setProperty(
      '--announcement-height',
      announcementBar.offsetHeight + 'px'
    );
  }
}

window.addEventListener('load', setAnnouncementHeight);
window.addEventListener('resize', debounce(setAnnouncementHeight, 100));